module.exports = __webpack_public_path__ + "img/consult_info4.e975bc12.png";